export class FetchAreasAction {
  static readonly type = '[Area] Fetch Areas';
}
